export const encode = (s, k) => btoa(btoa(btoa(s)));
export const decode = (s, k) => atob(atob(atob(s)));